import {createRouter, createWebHashHistory} from 'vue-router';

const routes = [
    {
        path: '/',
        name: 'home',
        exact: true,
        component: () => import('./components/authentication/Login.vue')
    },
    {
        path: '/login',
        name: 'login',
        exact: true,
        component: () => import('./components/authentication/Login.vue')
    },
    {
        path: '/register',
        name: 'register',
        exact: true,
        component: () => import('./components/authentication/Register.vue')
    },
    {
        path: '/pricing',
        name: 'pricing',
        exact: true,
        component: () => import('./components/authentication/Pricing.vue')
    },
    {
        path: '/error',
        name: 'error',
        exact: true,
        component: () => import('./components/authentication/Error.vue')
    },
    {
        path: '/test',
        name: 'test',
        exact: true,
        component: () => import('./components/common/Test.vue')
    },
    {
        path: '/commonProfile',
        name: 'commonProfile',
        exact: true,
        component: () => import('./components/common/Profile.vue')
    },
    {
        path: '/commonNotifications',
        name: 'commonNotifications',
        exact: true,
        component: () => import('./components/common/Notifications.vue')
    },
    {
        path: '/commonProfilePassword',
        name: 'commonProfilePassword',
        exact: true,
        component: () => import('./components/common/ProfilePassword.vue')
    },
    {
        path: '/commonProfileAccount',
        name: 'commonProfileAccount',
        exact: true,
        component: () => import('./components/common/ProfileAccount.vue')
    },
    {
        path: '/commonProfileTerms',
        name: 'commonProfileTerms',
        exact: true,
        component: () => import('./components/common/ProfileTerms.vue')
    },
    {
        path: '/commonProfilePrivacy',
        name: 'commonProfilePrivacy',
        exact: true,
        component: () => import('./components/common/ProfilePrivacy.vue')
    },
    {
        path: '/commonOverviewAuditTrail',
        name: 'commonOverviewAuditTrail',
        exact: true,
        component: () => import('./components/common/AuditTrail.vue')
    },
    {
        path: '/commonOverviewTasks',
        name: 'commonOverviewTasks',
        exact: true,
        component: () => import('./components/common/Tasks.vue')
    },
    {
        path: '/commonProspects',
        name: 'commonProspects',
        exact: true,
        component: () => import('./components/common/Prospects.vue')
    },
    {
        path: '/commonOverviewProcesses',
        name: 'commonOverviewProcesses',
        exact: true,
        component: () => import('./components/common/Processes.vue')
    },
    {
        path: '/commonAppointments',
        name: 'commonAppointments',
        exact: true,
        component: () => import('./components/common/Appointments.vue')
    },
    {
        path: '/commonReminders',
        name: 'commonReminders',
        exact: true,
        component: () => import('./components/common/Reminders.vue')
    },
    {
        path: '/commonPhoneCalls',
        name: 'commonPhoneCalls',
        exact: true,
        component: () => import('./components/common/PhoneCalls.vue')
    },
    {
        path: '/commonProducts',
        name: 'commonProducts',
        exact: true,
        component: () => import('./components/common/Products.vue')
    },
    {
        path: '/commonSuppliers',
        name: 'commonSuppliers',
        exact: true,
        component: () => import('./components/common/Suppliers.vue')
    },
    {
        path: '/commonConfigurationBasic',
        name: 'commonConfigurationBasic',
        exact: true,
        component: () => import('./components/common/ConfigurationBasic.vue')
    },
    {
        path: '/commonConfigurationBusiness',
        name: 'commonConfigurationBusiness',
        exact: true,
        component: () => import('./components/common/ConfigurationBusiness.vue')
    },
    {
        path: '/commonConfigurationBankAccounts',
        name: 'commonConfigurationBankAccounts',
        exact: true,
        component: () => import('./components/common/ConfigurationBankAccounts.vue')
    },
    {
        path: '/commonConfigurationEmail',
        name: 'commonConfigurationEmail',
        exact: true,
        component: () => import('./components/common/ConfigurationEmail.vue')
    },
    {
        path: '/commonConfigurationTemplates',
        name: 'commonConfigurationTemplates',
        exact: true,
        component: () => import('./components/common/ConfigurationTemplates.vue')
    },
    {
        path: '/commonConfigurationForms',
        name: 'commonConfigurationForms',
        exact: true,
        component: () => import('./components/common/ConfigurationForms.vue')
    },
    {
        path: '/commonConfigurationLocations',
        name: 'commonConfigurationLocations',
        exact: true,
        component: () => import('./components/common/ConfigurationLocations.vue')
    },
    {
        path: '/commonConfigurationBilling',
        name: 'commonConfigurationBilling',
        exact: true,
        component: () => import('./components/common/ConfigurationBilling.vue')
    },
    {
        path: '/commonConfigurationNoteTemplates',
        name: 'commonConfigurationNoteTemplates',
        exact: true,
        component: () => import('./components/common/ConfigurationNoteTemplates.vue')
    },
    {
        path: '/commonClients',
        name: 'commonClients',
        exact: true,
        component: () => import('./components/common/Clients.vue'),
        props: route => ({
            inputClientId: route.query.inputClientId,
            inputActiveTab: route.query.inputActiveTab,
        })
    },
    {
        path: '/commonFinancialInvoices',
        name: 'commonFinancialInvoices',
        exact: true,
        component: () => import('./components/common/Invoices.vue'),
        props: route => ({
            inputAppointmentId: route.query.inputAppointmentId,
            inputInvoiceId: route.query.inputInvoiceId
        })
    },
    {
        path: '/commonFinancialPayments',
        name: 'commonFinancialPayments',
        exact: true,
        component: () => import('./components/common/Payments.vue')
    },
    {
        path: '/commonFinancialBillingRuns',
        name: 'commonFinancialBillingRuns',
        exact: true,
        component: () => import('./components/common/BillingRuns.vue')
    },
    {
        path: '/commonFinancialUnpaidRuns',
        name: 'commonFinancialUnpaidRuns',
        exact: true,
        component: () => import('./components/common/UnpaidRuns.vue')
    },
    {
        path: '/commonFinancialManagement',
        name: 'commonFinancialManagement',
        exact: true,
        component: () => import('./components/common/FinancialManagement.vue')
    },
    {
        path: '/businessApplications',
        name: 'businessApplications',
        exact: true,
        component: () => import('./components/business/Applications.vue')
    },
    {
        path: '/healthOverviewPlanning',
        name: 'healthOverviewPlanning',
        exact: true,
        component: () => import('./components/health/Planning.vue')
    },
    {
        path: '/healthOverviewQualification',
        name: 'healthOverviewQualification',
        exact: true,
        component: () => import('./components/health/Qualification.vue')
    },
    {
        path: '/commonCalendar',
        name: 'commonCalendar',
        exact: true,
        component: () => import('./components/common/Calendar.vue')
    },
    {
        path: '/commonSearch',
        name: 'commonSearch',
        exact: true,
        component: () => import('./components/common/Search.vue')
    },
    {
        path: '/commonOverviewReports',
        name: 'commonOverviewReports',
        exact: true,
        component: () => import('./components/common/OverviewReports.vue')
    },
    {
        path: '/commonOverviewFiles',
        name: 'commonOverviewFiles',
        exact: true,
        component: () => import('./components/common/OverviewFiles.vue')
    },
    {
        path: '/commonOverviewDashboard',
        name: 'commonOverviewDashboard',
        exact: true,
        component: () => import('./components/common/OverviewDashboard.vue')
    },
    {
        path: '/commonHelp',
        name: 'commonHelp',
        exact: true,
        component: () => import('./components/common/Help.vue')
    },
    {
        path: '/commonDigitalForms',
        name: 'commonDigitalForms',
        exact: true,
        component: () => import('./components/common/DigitalForms.vue')
    },
    {
        path: '/commonAdminOverview',
        name: 'commonAdminOverview',
        exact: true,
        component: () => import('./components/common/AdminOverview.vue')
    },
    {
        path: '/healthApplications',
        name: 'healthApplications',
        exact: true,
        component: () => import('./components/health/Applications.vue')
    },
    {
        path: '/healthConfigurationPractitioners',
        name: 'healthConfigurationPractitioners',
        exact: true,
        component: () => import('./components/health/ConfigurationPractitioners.vue')
    },
    {
        path: '/healthFinancialClaims',
        name: 'healthFinancialClaims',
        exact: true,
        component: () => import('./components/health/Claims.vue')
    },
    {
        path: '/pmOverviewHome',
        name: 'pmOverviewHome',
        exact: true,
        component: () => import('./components/pmmodule/OverviewHome.vue')
    },
    {
        path: '/msOverviewHome',
        name: 'msOverviewHome',
        exact: true,
        component: () => import('./components/msmodule/OverviewHome.vue')
    },
    {
        path: '/faOverviewHome',
        name: 'faOverviewHome',
        exact: true,
        component: () => import('./components/famodule/OverviewHome.vue')
    },
    {
        path: '/sbOverviewHome',
        name: 'sbOverviewHome',
        exact: true,
        component: () => import('./components/sbmodule/OverviewHome.vue')
    },
    {
        path: '/siOverview',
        name: 'siOverview',
        exact: true,
        component: () => import('./components/simodule/Overview.vue')
    },
    {
        path: '/siPlan',
        name: 'siPlan',
        exact: true,
        component: () => import('./components/simodule/Plan.vue')
    },
    {
        path: '/siTrack',
        name: 'siTrack',
        exact: true,
        component: () => import('./components/simodule/Track.vue')
    },
    {
        path: '/siAchieve',
        name: 'siAchieve',
        exact: true,
        component: () => import('./components/simodule/Achieve.vue')
    },
    {
        path: '/siAdmin',
        name: 'siAdmin',
        exact: true,
        component: () => import('./components/simodule/Admin.vue')
    },
    {
        path: '/siApplications',
        name: 'siApplications',
        exact: true,
        component: () => import('./components/simodule/Applications.vue')
    },
    {
        path: '/siCourse',
        name: 'siCourse',
        exact: true,
        component: () => import('./components/simodule/Course.vue')
    },
    {
        path: '/siPricingLegacy',
        name: 'siPricingLegacy',
        exact: true,
        component: () => import('./components/simodule/Pricing.vue'),
        props: route => ({
            affiliateId: route.query.affiliateId
        })
    },
    {
        path: '/siPricing',
        name: 'siPricing',
        exact: true,
        component: () => import('./components/simodule/PricingStripe.vue'),
        props: route => ({
            affiliateId: route.query.affiliateId
        })
    },
    {
        path: '/siPricingSuccessful',
        name: 'siPricingSuccessful',
        exact: true,
        component: () => import('./components/simodule/PricingSuccessful.vue'),
        props: route => ({
            affiliateId: route.query.affiliateId
        })
    },
    {
        path: '/siPricingCancelled',
        name: 'siPricingCancelled',
        exact: true,
        component: () => import('./components/simodule/PricingCancelled.vue'),
        props: route => ({
            affiliateId: route.query.affiliateId
        })
    },
    {
        path: '/siAffiliate',
        name: 'siAffiliate',
        exact: true,
        component: () => import('./components/simodule/Affiliate.vue')
    },
    {
        path: '/siAffiliateClients',
        name: 'siAffiliateClients',
        exact: true,
        component: () => import('./components/simodule/AffiliateClients.vue')
    },
    {
        path: '/siAffiliateInvoices',
        name: 'siAffiliateInvoices',
        exact: true,
        component: () => import('./components/simodule/AffiliateInvoices.vue')
    },
    {
        path: '/siAffiliateConfiguration',
        name: 'siAffiliateConfiguration',
        exact: true,
        component: () => import('./components/simodule/AffiliateConfiguration.vue')
    },
    {
        path: '/siAffiliateConfigurationPassword',
        name: 'siAffiliateConfigurationPassword',
        exact: true,
        component: () => import('./components/simodule/AffiliateConfigurationPassword.vue')
    },
    {
        path: '/siProfile',
        name: 'siProfile',
        exact: true,
        component: () => import('./components/simodule/Profile.vue')
    },
    {
        path: '/siHelp',
        name: 'siHelp',
        exact: true,
        component: () => import('./components/simodule/Help.vue')
    },
    {
        path: '/siGlossary',
        name: 'siGlossary',
        exact: true,
        component: () => import('./components/simodule/Glossary.vue')
    },
    {
        path: '/siNotifications',
        name: 'siNotifications',
        exact: true,
        component: () => import('./components/simodule/Notifications.vue')
    },
    {
        path: '/siLogin',
        name: 'siLogin',
        exact: true,
        component: () => import('./components/simodule/Login.vue')
    },
    {
        path: '/siConfiguration',
        name: 'siConfiguration',
        exact: true,
        component: () => import('./components/simodule/Configuration.vue')
    },
    {
        path: '/siConfigurationUpgrade',
        name: 'siConfigurationUpgrade',
        exact: true,
        component: () => import('./components/simodule/ConfigurationUpgrade.vue')
    },
    {
        path: '/siConfigurationUpgradeCancelled',
        name: 'siConfigurationUpgradeCancelled',
        exact: true,
        component: () => import('./components/simodule/ConfigurationUpgradeCancelled.vue')
    },
    {
        path: '/siConfigurationUpgradeSuccessful',
        name: 'siConfigurationUpgradeSuccessful',
        exact: true,
        component: () => import('./components/simodule/ConfigurationUpgradeSuccessful.vue')
    },
    {
        path: '/siConfigurationPassword',
        name: 'siConfigurationPassword',
        exact: true,
        component: () => import('./components/simodule/ConfigurationPassword.vue')
    },
    {
        path: '/siConfigurationAlerts',
        name: 'siConfigurationAlerts',
        exact: true,
        component: () => import('./components/simodule/ConfigurationAlerts.vue')
    },
    {
        path: '/siConfigurationEmailLists',
        name: 'siConfigurationEmailLists',
        exact: true,
        component: () => import('./components/simodule/ConfigurationEmailLists.vue')
    },
    {
        path: '/siForgotPassword',
        name: 'siForgotPassword',
        exact: true,
        component: () => import('./components/simodule/ForgotPassword.vue')
    },
    {
        path: '/siForgotPasswordSubmission',
        name: 'siForgotPasswordSubmission',
        exact: true,
        component: () => import('./components/simodule/ForgotPasswordSubmission.vue')
    },
    {
        path: '/userOverview',
        name: 'userOverview',
        exact: true,
        component: () => import('./components/usermodule/Overview.vue')
    },
    {
        path: '/application5',
        name: 'application5',
        exact: true,
        component: () => import('./components/applications/Application5.vue')
    },
    {
        path: '/application11',
        name: 'application11',
        exact: true,
        component: () => import('./components/applications/Application11.vue')
    },
    // {
    //     path: '/form',
    //     name: 'Form',
    //     component: () => import('./components/common/Form.vue.orig'),
    // },
    {
        path: '/formSuccessful',
        name: 'FormSuccessful',
        component: () => import('./components/common/FormSuccessful.vue'),
    },
    {
        path: '/formError',
        name: 'FormError',
        component: () => import('./components/common/FormError.vue'),
    },
    {
        path: '/booking',
        name: 'Booking',
        component: () => import('./components/common/Booking.vue'),
    },
    {
        path: '/bookingSuccessful',
        name: 'BookingSuccessful',
        component: () => import('./components/common/BookingSuccessful.vue'),
    },
    {
        path: '/bookingError',
        name: 'BookingError',
        component: () => import('./components/common/BookingError.vue'),
    },
    {
        path: '/sa/clientintake',
        name: 'ClientIntake',
        component: () => import('./components/common/ClientIntake.vue'),
    },
    {
        path: '/sa/clientintakecouples',
        name: 'ClientIntakeCouples',
        component: () => import('./components/common/ClientIntakeCouples.vue'),
    },
    {
        path: '/clientintakeSuccessful',
        name: 'ClientIntakeSuccessful',
        component: () => import('./components/common/ClientIntakeSuccessful.vue'),
    },
    {
        path: '/clientintakeError',
        name: 'ClientIntakeError',
        component: () => import('./components/common/ClientIntakeError.vue'),
    },
    {
        path: '/digitalform',
        name: 'DigitalForm',
        component: () => import('./components/common/DigitalForm.vue'),
    },
    {
        path: '/digitalbooking',
        name: 'DigitalBooking',
        component: () => import('./components/common/DigitalBooking.vue'),
    },
    {
        path: '/isogrowLogin',
        name: 'isogrowLogin',
        exact: true,
        component: () => import('./components/isogrow/Login.vue')
    },
    {
        path: '/isogrowOverview',
        name: 'isogrowOverview',
        exact: true,
        component: () => import('./components/isogrow/Overview.vue')
    },
    {
        path: '/:pathMatch(.*)*', // This will catch all undefined routes
        redirect: '/error', // Redirect to the error component
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes: routes,
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition)
            return savedPosition
        else
            return { left: 0, top: 0 };
    }
});

export default router;
